import { useEffect, useState } from "react";
import { Loader2, Download } from "lucide-react";
import api from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { SfPdfPages } from "./SfPdfPages";

export const SfPreviewDialog = ({ file, onClose }) => {
  const [url, setUrl] = useState(null);
  const ct = (file?.content_type || "").toLowerCase();
  useEffect(() => {
    if (!file) return;
    let obj = null, on = true;
    setUrl(null);
    (async () => {
      if (ct.startsWith("image/")) try {
        const { data } = await api.get(`/studio/allegati-studio/files/${file.id}/content-url`);
        if (data.url) { if (on) setUrl(data.url); return; }
      } catch { /* fallback streaming */ }
      const { data: blob } = await api.get(`/studio/allegati-studio/files/${file.id}/content`, { responseType: "blob" });
      obj = URL.createObjectURL(new Blob([blob], { type: ct || blob.type }));
      if (on) setUrl(obj);
    })().catch(() => {});
    return () => { on = false; if (obj) URL.revokeObjectURL(obj); };
  }, [file, ct]);

  return (
    <Dialog open={!!file} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-5xl w-[95vw]" data-testid="sf-preview-dialog">
        <DialogHeader><DialogTitle className="truncate pr-6">{file?.nome}</DialogTitle></DialogHeader>
        <div className="h-[75vh] flex items-center justify-center bg-slate-100 rounded-lg overflow-hidden">
          {!url ? <Loader2 className="h-6 w-6 animate-spin text-slate-500" />
            : ct.startsWith("image/") ? <img src={url} alt={file?.nome} className="max-h-full max-w-full object-contain" data-testid="sf-preview-image" />
            : ct === "application/pdf" ? <SfPdfPages url={url} />
            : ct.startsWith("text/") ? <iframe src={url} title={file?.nome} className="w-full h-full bg-white" data-testid="sf-preview-frame" />
            : (
              <div className="text-center space-y-3" data-testid="sf-preview-nopreview">
                <p className="text-sm text-slate-600">Anteprima non disponibile per questo tipo di file.</p>
                <a href={url} download={file?.nome} data-testid="sf-preview-download" className="inline-flex items-center gap-1.5 rounded-lg bg-amber-500 hover:bg-amber-600 px-4 py-2 text-sm font-semibold text-[#0a0d14] transition-colors"><Download className="h-4 w-4" />Scarica</a>
              </div>
            )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
